/* src/app/core/components/main/main.component.scss */
:host {
  flex-grow: 1;
}
.page-content {
  min-height: calc(100vh - var(--pbds-footer-height));
}
.content-margin {
  margin: 2rem;
}
/*# sourceMappingURL=main.component.css.map */
